import React from "react";

export const Pen = () => (
  <>
    <svg
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.2255 3.23723C11.8465 2.56442 12.157 2.22801 12.4869 2.03179C13.283 1.55831 14.2633 1.54359 15.0727 1.99295C15.4081 2.17918 15.7282 2.50612 16.3683 3.15998C17.0083 3.81385 17.3284 4.14079 17.5107 4.48345C17.9506 5.31028 17.9362 6.31168 17.4727 7.12494C17.2806 7.46198 16.9513 7.77916 16.2926 8.41352L8.45625 15.9613C7.20813 17.1634 6.58406 17.7645 5.80411 18.0691C5.02416 18.3738 4.16673 18.3513 2.45187 18.3065L2.21854 18.3004C1.69648 18.2867 1.43545 18.2799 1.28372 18.1077C1.13198 17.9355 1.1527 17.6696 1.19413 17.1378L1.21663 16.8491C1.33324 15.3523 1.39154 14.6039 1.68382 13.9312C1.9761 13.2585 2.48026 12.7122 3.48858 11.6198L11.2255 3.23723Z"
        stroke="#344054"
        stroke-width="1.5"
        stroke-linejoin="round"
      />
      <path
        d="M10.3281 3.33203L16.1615 9.16537"
        stroke="#344054"
        stroke-width="1.5"
        stroke-linejoin="round"
      />
      <path
        d="M11.1641 18.332L17.8307 18.332"
        stroke="#344054"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </>
);

export const PenSmall = () => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.728 3.238c.621-.673.932-1.009 1.262-1.205a2.589 2.589 0 012.585-.04c.336.187.656.514 1.296 1.168.64.654.96.98 1.142 1.323.44.827.426 1.829-.038 2.642-.192.337-.521.654-1.18 1.288L8.96 15.963c-1.248 1.202-1.872 1.803-2.652 2.108-.78.305-1.638.282-3.352.238L2.72 18.3c-.522-.013-.783-.02-.935-.192-.151-.173-.13-.438-.09-.97l.023-.289c.117-1.497.175-2.245.468-2.918.292-.673.796-1.219 1.804-2.311l7.737-8.383zM10.834 3.334l5.833 5.833"
      stroke="#344054"
      strokeWidth={1.2}
      strokeLinejoin="round"
    />
    <path
      d="M11.667 18.334h6.666"
      stroke="#344054"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
